import Vue from 'vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AppBarComponent from '@/components/AppBarComponent'
import SidenavComponent from '@/components/SidenavComponent'
import LocalesComponent from '@/components/LocalesComponent'
import SideMenuComponent from '@/components/SideMenuComponent'
import ModalComponent from '@/components/ModalComponent'
import AlertComponent from '@/components/AlertComponent'
import InteractiveMapV3Component from '@/components/InteractiveMapV3Component'
import InfoTableComponent from '@/components/InfoTableComponent'
import VisitsInfoV2Component from '@/components/VisitsInfoV2Component'
import InfoPieChartComponent from '@/components/InfoPieChartComponent'
import AddNewSubscriberDialog from '@/components/AddNewSubscriberDialog'
import UpdateSubscriberDialog from '@/components/UpdateSubscriberDialog'

Vue.component('validation-observer', ValidationObserver)
Vue.component('validation-provider', ValidationProvider)
Vue.component('app-bar-component', AppBarComponent)
Vue.component('sidenav-component', SidenavComponent)
Vue.component('locales-component', LocalesComponent)
Vue.component('side-menu-component', SideMenuComponent)
Vue.component('modal-component', ModalComponent)
Vue.component('alert-component', AlertComponent)
Vue.component('interactive-map-v3', InteractiveMapV3Component)
Vue.component('info-table-component', InfoTableComponent)
Vue.component('visits-info-v2-component', VisitsInfoV2Component)
Vue.component('info-pie-chart-component', InfoPieChartComponent)
Vue.component('add-new-subscriber-dialog', AddNewSubscriberDialog)
Vue.component('update-subscriber-dialog', UpdateSubscriberDialog)
